import packageJson from '../../package.json';

export const APP_NAME = 'BWI 10 Review';
export const RELEASE_VERSION = process.env.REACT_APP_RELEASE_VERSION || packageJson.version;
export const RELEASED_AT = process.env.REACT_APP_RELEASED_AT || '';
export const RELEASE_ID = [RELEASE_VERSION, RELEASED_AT].filter(Boolean).join('@');

export const RELEASE_STORAGE_KEY = 'appReleaseId';
export const RELEASE_LOGOUT_MESSAGE_KEY = 'releaseLogoutMessage';

export const formatReleaseDate = (value: string) => {
  if (!value) return 'Not set';

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(parsed);
};
